import { isNil } from "lodash";

export default function convertPrice(price: number | null | undefined) {
  if (isNil(price)) return null;
  return price.toLocaleString("en-us", {
    style: "currency",
    currency: "USD",
  });
}
